import {useMainStore} from "@/store";
import StorageManager from "@/services/storageManager";

const authenticated = async () => {
    const store = useMainStore();

    if (store.loggedIn) {
        return;
    }

    if (! StorageManager.has('identifier')) {
        return {name: store.isNative ? 'register' : 'login'};
    }

    try {
        await store.connectRequest({identifier: StorageManager.get('identifier')});
    } catch (e) {
        if (e.response !== undefined && e.response.status === 503) {
            return {name: 'maintenance'};
        }

        // Server completely unreachable (network error) — show downtime screen
        // without wiping the identifier so we can reconnect when it's back.
        if (e.response === undefined) {
            store.SET_MAINTENANCE({unreachable: true});
            return {name: 'maintenance'};
        }

        // Actual auth/server failure with a response — wipe session
        StorageManager.delete('identifier');
        return {name: store.isNative ? 'register' : 'login'};
    }
};

export default authenticated;
